<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">Index</li>
      </ol>
    </nav>

    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'organizationModule.organizations' | translate }}
      </h1>

      <div>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onClickCreate()"
          [canSee]="[accessRights.Organizations_write]"
        >
          {{ 'general.create' | translate }}
        </button>
      </div>
    </div>
  </header>
  <!-- End Page Header -->
  <div class="d-flex">
    <dms-switch
      [defaultActiveItem]="defaultTab"
      [textItem1]="'general.active'"
      [textItem2]="'general.inactive'"
      [responseItem1]="true"
      [responseItem2]="false"
      (onEmitItem1)="form.controls['isActive'].patchValue($event)"
      (onEmitItem2)="form.controls['isActive'].patchValue($event)"
    >
    </dms-switch>
  </div>
  <div class="w-100">
    <dms-table
      [activeTab]="actualTab"
      [isLoading]="isLoading$ | async"
      [showTotal]="true"
      [tableType]="'organizations'"
      (onBulkAction)="onBulkAction($event)"
      (onClickRow)="onClickRow($event)"
      (onTab)="onTabSelected($event)"
    >
    </dms-table>
  </div>
</div>
